.badge {
    cursor: pointer;
}
